import { usePathname } from 'expo-router';
import React, { useEffect } from 'react';

export const useScrollToTop = () => {
  const pathname = usePathname();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant', // Use 'smooth' for animated scrolling
    });
  }, [pathname]);
};

export const ScrollToTop = React.memo(() => {
  useScrollToTop();
  return <></>;
});
